export default __webpack_public_path__ + "static/media/checkin_code_icon.626b8e67.svg";